export const kioskAlertsResource = {
  name: 'Kiosk alerts',
  fields: { severity: 'Severity', alert: 'Alert', kiosk: 'Kiosk', site: 'Site', raisedAt: 'Raised', status: 'State', outcome: 'Handled or fixed' },
  filters: { status: 'State', all: 'All', kind: 'Alert', site: 'Site', kiosk: 'Kiosk', from: 'From', to: 'To' },
  severities: { critical: 'Critical', warning: 'Warning', info: 'Info' },
  statuses: { open: 'Open', handled: 'Handled', cleared: 'Fixed itself' },
  handledBy: 'Handled by %{name} at %{time}',
  clearedAt: 'Fixed itself at %{time}',
  sections: { timeline: 'Timeline', details: 'Details' },
  timeline: { raised: 'Raised', handled: 'Handled', note: 'Note', cleared: 'Fixed itself' },
  noDetails: 'No details',
  handle: {
    button: 'Mark handled',
    title: 'Mark this alert handled',
    body: 'Write what was done. The alert stays handled while the problem lasts. If the problem clears and comes back, a new alert is raised.',
    note: 'Note',
    noteHelper: 'Required, up to 500 characters. Do not enter card numbers or phone numbers.',
    confirm: 'Mark handled',
    done: 'Alert marked handled',
    notOpen: 'This alert is no longer open. The page has been refreshed.',
    failed: 'Could not mark the alert handled',
  },
  deviceChip: { column: 'Alerts', open: '%{count} open', none: 'None' },
  recent: { title: 'Recent alerts', empty: 'No alerts yet', viewAll: 'View all alerts', loadFailed: 'Could not load the alerts: %{error}' },
};

export const kioskAlerts = kioskAlertsResource;
